import axios, {AxiosError} from "axios";
import { API_URL, GetFilingResult } from "../constant";
import { FetchFilingResult, FetchFilingRequest } from "../constant";
import { message} from 'antd';

  
export async function FectchFiling(requestdata: FetchFilingRequest): Promise<FetchFilingResult> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };

        //message.loading({ content: 'Filing fetching...', key: 'fetchStatus' });
        const response = await axios.post(
          `${API_URL}api/filing/fetch`,
          requestdata,
          config
        );
    
        if (response.status === 200)
        {
            console.log(`Fetch filing success, ${response.data.length}`);
            //message.success({ content: 'Fetch filing successful!', key: 'fetchStatus', duration: 2 });
            return { success: true, fetchedList: response.data };
        }
        else if (response.status === 422)
        {
            //message.error({ content: 'Fetch error: Validation Error.', key: 'fetchStatus', duration: 2 });
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            //message.error({ content: 'Fetch error: Unexpected status code.', key: 'fetchStatus', duration: 2 });
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function api_getFiling(policyNumber: string): Promise<GetFilingResult> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
            validateStatus: (status: number) => {
                return status >= 200 && status < 500
            }
          };

        const response = await axios.post(
          `${API_URL}api/filing/getfiling`,
          {policyNumber: policyNumber},
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, filing: response.data };
        }
        else if (response.status === 404)
        {
            return { success: false, errorMsg: "Failed: Policy number not found" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}